// ar phases
import type Pageable from 'models/Pageable';
import type { ArPhaseVO, ArPhaseVOModel } from 'models/vo/ArPhaseVO';
import { formattingToArPhaseVOModel } from 'models/vo/ArPhaseVO';
import http from 'utils/http';
import API_DE from 'utils/http/api/dealer';

export async function requestDealerArPhaseList(
  pageNumber: number,
  rowCount: number,
  arSummaryId: number,
): Promise<Pageable<ArPhaseVOModel[]>> {
  const response = await http.get<Pageable<ArPhaseVO[]>>({
    url: API_DE.AR_APPROVAL_PHASES.AR_PHASE_LIST,
    data: {
      pageNumber,
      rowCount,
      arSummaryId,
    },
  });
  const arSummaryList: ArPhaseVOModel[] = response.content.map((data: ArPhaseVO) => formattingToArPhaseVOModel(data));
  const arSummaryPage: Pageable<ArPhaseVOModel[]> = {
    ...response,
    content: arSummaryList,
  };

  return arSummaryPage;
}
